export default __webpack_public_path__ + "static/media/professionalDetailshelpMobileHighlight.ff9b2bcd.png";